import { create } from "zustand";
import { listUsers } from "@/lib/api";

interface OrgUserSummary {
	firstName: string;
	lastName: string;
}

interface OrgUsersState {
	usersById: Record<string, OrgUserSummary>;
	loaded: boolean;
	load: () => Promise<void>;
}

export const useOrgUsersStore = create<OrgUsersState>((set, get) => ({
	usersById: {},
	loaded: false,
	load: async () => {
		if (get().loaded) return;
		const users = await listUsers();
		const usersById: Record<string, OrgUserSummary> = {};
		for (const u of users) {
			usersById[u.id] = { firstName: u.firstName, lastName: u.lastName };
		}
		set({ usersById, loaded: true });
	},
}));
